import { useEffect } from "react";
import { api } from "../lib/api";

const THEME_CLASSES = ["theme-gold", "theme-neon-cyan", "theme-amethyst", "theme-emerald-volt", "theme-sunset-orange"];
const THEME_CACHE_KEY = "vj_theme_cache";

export function applyTheme(themeClass) {
  const resolved = THEME_CLASSES.includes(themeClass) ? themeClass : "theme-gold";
  document.documentElement.classList.remove(...THEME_CLASSES);
  document.documentElement.classList.add(resolved);
  try { window.localStorage.setItem(THEME_CACHE_KEY, resolved); } catch (e) {}
}

/** Fetches the platform-wide active theme (set by Admin) and applies it globally,
 * to both the Member and Admin surfaces. */
export function useAppTheme() {
  useEffect(() => {
    api.get("/settings/public").then(({ data }) => {
      applyTheme(data?.theme?.active_theme);
    }).catch(() => {});
  }, []);
}
